var map = {
	"./busd.svg": 2009,
	"./crypto-pending.png": 2010,
	"./crypto-reject.png": 2011,
	"./crypto-success.png": 2012,
	"./direpay.svg": 2013,
	"./trx.svg": 2014,
	"./usdc.svg": 2015,
	"./usdt.svg": 2016
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 151;